import { SortableFilter }          from './../common/sortable-filter';

export class BusRouteSortableFilter extends SortableFilter {
    public activeOnly = true;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-route-list/bus-route-sortable-filter.ts